import { render, staticRenderFns } from "./GeneralLedgerTransactionsGrid.vue?vue&type=template&id=563723ec&"
import script from "./GeneralLedgerTransactionsGrid.vue?vue&type=script&lang=ts&"
export * from "./GeneralLedgerTransactionsGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports